// Main page content
const main = {
  // 页面标题和描述
  pageTitle: "地址补全",
  pageDescription: "支持开头和末尾的模糊匹配，提供数据越全查找越精准",

  // 表单标签
  addressStartLabel: "地址开头",
  addressEndLabel: "地址末尾",

  // 表单占位符
  addressStartPlaceholder: "请输入至少4个地址开头字符（必填）",
  addressEndPlaceholder: "请输入地址末尾字符（非必填)",

  // 按钮
  queryButton: "查询",
  resetButton: "重置",

  // 状态提示
  loadingText: "拼命加载中",
  noDataText: "暂无数据",
  emptyPrompt: "请输入地址的开头或末尾进行查询",

  // 结果展示
  addressLabel: "地址",

  // 验证消息
  addressStartRequired: "请输入地址开头",

  // 通知消息
  copySuccess: "复制成功",
  notificationTitle: "提示",
  noResultsFound: "很抱歉，查询结果中没有找到相关数据",

  // 地址流入弹窗
  inflowDialog: {
    title: "地址流入交易概况",
    totalData: "共计",
    dataUnit: "条数据",
    download: "下载",
    loadingText: "拼命加载中",
    selectAddressFirst: "请先选择地址",
    queryInflow: "查询地址流入",
    dataLabel: "数据",
    dataCount: "条",
    tagLabel: "标签",
    blockchainLabel: "所属链",
    addressLabel: "地址",
    defaultHeaders: {
      address: "地址",
      tokenTotalInflow: "总流入(USDT)",
      mainCoinTotalInflow: "总流入(主币)",
    },
  },
};

// Hash completion page content
const hashCompletion = {
  // 页面标题和描述
  hashPageTitle: "哈希补全",
  hashPageDescription: "支持开头和末尾的模糊匹配，提供数据越全查找越精准",

  // 表单标签
  hashStartLabel: "哈希开头",
  hashEndLabel: "哈希末尾",

  // 表单占位符
  hashStartPlaceholder: "请输入哈希开头字符（必填）",
  hashEndPlaceholder: "请输入哈希末尾字符（非必填）",

  // 按钮
  hashQueryButton: "查询",
  hashResetButton: "重置",

  // 状态提示
  hashLoadingText: "拼命加载中",
  hashNoDataText: "暂无数据",
  hashEmptyPrompt: "请输入哈希的开头或末尾进行查询",

  // 结果展示
  hashLabel: "哈希",

  // 验证消息
  hashStartRequired: "请输入哈希开头",

  // 通知消息
  hashCopySuccess: "复制成功",
  hashNotificationTitle: "提示",
  hashNoResultsFound: "很抱歉，查询结果中没有找到相关数据",
};

export default {
  ...main,
  ...hashCompletion,

  // Sub-modules
};
